import { usePolicyInventory } from '../../policies/hooks/usePolicyInventory'

function ProgramSnapshot({ engagementType, benchmarkGap, client, enablementProgress }) {
  const isDiscovery = engagementType !== 'retainer'
  const { stats } = usePolicyInventory(client || {})

  const frameworks = Array.isArray(client?.regulatoryFrameworks) ? client.regulatoryFrameworks
    : Array.isArray(client?.regulatory_frameworks) ? client.regulatory_frameworks : []
  const hasInventory = stats.totalRecommended > 0
  const coveragePercent = hasInventory ? Math.round((stats.adopted / stats.totalRecommended) * 100) : 0

  const BenchmarkTile = () => (
    <div className="bg-white rounded-lg p-4" style={{ border: '1px solid #E2E8F0', borderTop: '3px solid #6366F1' }}>
      <p className="text-xs font-medium uppercase tracking-wider" style={{ color: '#64748B' }}>Peer Benchmark</p>
      {benchmarkGap != null ? (
        <>
          <p className="text-2xl font-bold mt-1" style={{ color: '#0F172A' }}>
            {benchmarkGap > 0 ? '+' : ''}{benchmarkGap}%
          </p>
          <p className="text-xs mt-0.5" style={{ color: '#94A3B8' }}>
            {benchmarkGap >= 5 ? 'Above industry average' : benchmarkGap >= -5 ? 'At industry average' : 'Below industry average'}
          </p>
        </>
      ) : (
        <>
          <p className="text-2xl font-bold mt-1" style={{ color: '#94A3B8' }}>&mdash;</p>
          <p className="text-xs mt-0.5" style={{ color: '#94A3B8' }}>Complete assessment first</p>
        </>
      )}
    </div>
  )

  if (isDiscovery) {
    return (
      <div className="max-w-[300px]">
        <BenchmarkTile />
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <BenchmarkTile />

      <div className="bg-white rounded-lg p-4" style={{ border: '1px solid #E2E8F0', borderTop: '3px solid #22C55E' }}>
        <p className="text-xs font-medium uppercase tracking-wider" style={{ color: '#64748B' }}>Policy Coverage</p>
        {hasInventory ? (
          <>
            <p className="text-2xl font-bold mt-1" style={{ color: '#0F172A' }}>
              {stats.adopted} / {stats.totalRecommended}
            </p>
            <div className="h-1.5 rounded-full mt-2" style={{ backgroundColor: '#E2E8F0' }}>
              <div
                className="h-1.5 rounded-full"
                style={{
                  width: `${coveragePercent}%`,
                  background: 'linear-gradient(90deg, #22C55E, #8AD0D6)'
                }}
              />
            </div>
            <div className="flex flex-wrap gap-1 mt-1.5">
              {frameworks.slice(0, 3).map(f => (
                <span key={f} className="text-[10px] px-1.5 py-0.5 rounded" style={{ backgroundColor: '#EFF6FF', color: '#2563EB' }}>
                  {f}
                </span>
              ))}
            </div>
          </>
        ) : (
          <>
            <p className="text-2xl font-bold mt-1" style={{ color: '#94A3B8' }}>&mdash;</p>
            <p className="text-xs mt-0.5" style={{ color: '#94A3B8' }}>Assessment pending</p>
          </>
        )}
      </div>

      <div className="bg-white rounded-lg p-4" style={{ border: '1px solid #E2E8F0', borderTop: '3px solid #3B82F6' }}>
        <p className="text-xs font-medium uppercase tracking-wider" style={{ color: '#64748B' }}>Enablement Progress</p>
        <p className="text-2xl font-bold mt-1" style={{ color: '#0F172A' }}>{enablementProgress || 0}%</p>
        <p className="text-xs mt-0.5" style={{ color: '#94A3B8' }}>plan completion</p>
      </div>
    </div>
  )
}

export default ProgramSnapshot
